(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function scrollToTarget(targetId) {
    if (!targetId) return false;
    const target = document.getElementById(targetId);
    if (!target) return false;

    target.scrollIntoView({
      behavior: reduceMotion ? "auto" : "smooth",
      block: "start"
    });

    if (typeof target.focus === "function") {
      const previousTabIndex = target.getAttribute("tabindex");
      if (previousTabIndex === null) target.setAttribute("tabindex", "-1");
      target.focus({ preventScroll: true });
      if (previousTabIndex === null) {
        target.addEventListener(
          "blur",
          () => target.removeAttribute("tabindex"),
          { once: true }
        );
      }
    }

    return true;
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-acc-ro-smooth-scroll]");
    if (!trigger) return;

    const targetId = trigger.getAttribute("data-acc-ro-scroll-target");
    if (!targetId) return;

    if (scrollToTarget(targetId)) {
      event.preventDefault();
    }
  });
})();
